import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { AmazonMWSCopySource } from '../../model/pipeline/copysource/amazon-mws.copysource';
import { Metamodel } from 'app/model/base/model';
import { useEncryptedEndpointsRadioSwitch } from './linked-service-shared-fields';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const amazonMWSMetadata: ILinkedServiceTypeMetadata = {
    type: 'AmazonMWS',
    displayName: stringResources.AmazonMWS_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-aws_marketplace'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(AmazonMWSCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'endpoint',
            label: stringResources.ModelName_Endpoint,
            placeholder: stringResources.AmazonMWSEndpointPlaceholder,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'marketplaceID',
            label: stringResources.ModelName_MarketplaceID,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'sellerID',
            label: stringResources.ModelName_SellerID,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'mwsAuthToken',
            label: stringResources.ModelName_MwsAuthToken,
            child: {
                type: 'password',
                label: stringResources.ModelName_MwsAuthToken,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template, stringResources.AmazonMWS_DisplayText,
                stringResources.ModelName_MwsAuthToken)
        },
        {
            type: 'textbox',
            bind: 'accessKeyId',
            label: stringResources.ModelName_AccessKeyID,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'secretKey',
            label: stringResources.ModelName_AmazonAccessKey,
            child: {
                type: 'password',
                label: stringResources.ModelName_AmazonAccessKey,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template, stringResources.AmazonMWS_DisplayText,
                stringResources.ModelName_AmazonAccessKey)
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
